import {
    ACTIONS,
    Action,
    LIMIT_AREA,
    LIMIT_TYPE,
    LimitsConfig,
} from '@main/components/limits-notification/limits-notification.types';
import { INTERVAL_TYPE } from '@main/enums';

const VIEWS_IMAGE = 'assets/images/limits-page/report-views-limit.png';
const SUBSCRIPT = 'Please contact your account administrator to increase this.';

const contactAdminAction: Action = {
    actionId: ACTIONS.CONTACT_ADMIN,
    caption: 'Contact administrator',
    color: 'accent',
    svgIcon: 'house',
};

export const generateDefaultLimitWarningsConfig = (): LimitsConfig => ({
    [LIMIT_TYPE.VIEW]: {
        [LIMIT_AREA.GLOBAL]: {
            [INTERVAL_TYPE.DAILY]: {
                mailSubject: 'My number of daily reports available has been exceeded',
                headerImage: VIEWS_IMAGE,
                title: 'You have exceeded the number of daily reports available',
                subscript: SUBSCRIPT,
                actions: [contactAdminAction],
            },
            [INTERVAL_TYPE.MONTHLY]: {
                mailSubject: 'My number of monthly reports available has been exceeded',
                headerImage: VIEWS_IMAGE,
                title: 'You have exceeded the number of monthly reports available',
                subscript: SUBSCRIPT,
                actions: [contactAdminAction],
            },
        },
    },
});
